import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9984 4.32008L8.00905 1.82764L1.625 5.65694L2.65377 7.37206L2.99694 7.16622V22.0001H7V15H9V22.0001H15V15H17V22.0001H20.9999V7.16622L21.343 7.37206L22.3718 5.65694L15.9878 1.82764L11.9984 4.32008ZM7 8.99805H9.00391V11.002H7V8.99805ZM17.0039 8.99805V11.002H15V8.99805H17.0039Z"}}]};

const City9Filled = Vue.extend<IconProps>({
  name: 'City9FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-9-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default City9Filled;
